<!-- 劳务公司的查看详细 -->
<template>
  <!-- 向上检测父组件方法 -->
  <div class="button" @click="goDetails">
    <div>
      <img style="width:14px;height:16px" src="@/assets/hideBox/detail.png" alt />
      <span>查看详情</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "openDetail",
  inject:['cardListCom'],
  props:{
    item:Object
  },
  methods: {
    //跳转详情
    goDetails({ no }) {
      let routeUrlC = `${process.env.VUE_APP_MATERIALSURL}/company/?no=${this.item.no}&type=1&subMenuId=7`
      window.open(routeUrlC, "_blank")
    }
  }
}
</script>

<style scoped>

</style>
